export const profileMenuData = {
	admin: {
		tabs: [
			{
				title: 'Katalog pojazdów',
				translationKey: 'product_catalog',
				icon: 'car',
				href: '/panel/product-catalog',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Parametry',
				translationKey: 'upsell',
				icon: 'arrow-up-circle',
				href: '/panel/parameters',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Kody rabatowe',
				translationKey: 'discount_codes',
				icon: 'percentage-square',
				href: '/panel/discount-codes',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Lokalizacje',
				translationKey: 'locations',
				icon: 'like',
				href: '/panel/locations',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Główne Podstrony',
				translationKey: 'locations',
				icon: 'monitor',
				href: '/panel/main-subpages',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			{
				title: 'Inne Podstrony',
				translationKey: 'locations',
				icon: 'monitor',
				href: '/panel/subpages',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			{
				title: 'Miasta',
				translationKey: 'locations',
				icon: 'monitor',
				href: '/panel/cms-locations',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			{
				title: 'Menu Oferta',
				translationKey: 'mega_menu',
				icon: 'monitor',
				href: '/panel/mega-menu',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			// {
			// 	title: 'Programy lojalnościowe',
			// 	translationKey: 'loyalty_programs',
			// 	icon: 'like',
			// 	href: '/panel/loyalty-programs',
			// 	requieredPermission: EUserPermissions.ADMIN,
			// 	subtabs: [],
			// },
			{
				title: 'Blog',
				translationKey: 'news',
				icon: 'monitor',
				href: '/panel/news',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			{
				title: 'Kategorie bloga',
				translationKey: 'news',
				icon: 'monitor',
				href: '/panel/news-categories',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			{
				title: 'Autorzy bloga',
				translationKey: 'news',
				icon: 'monitor',
				href: '/panel/authors',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
			{
				title: 'Zadatek',
				translationKey: null,
				icon: 'percentage-square',
				href: '/panel/advance-rate-periods',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Oceny Google',
				translationKey: 'google_ratings',
				icon: 'monitor',
				href: '/panel/google-ratings',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Oceny Trustpilot',
				translationKey: 'trustpilot_ratings',
				icon: 'monitor',
				href: '/panel/trustpilot-ratings',
				requieredPermission: EUserPermissions.ADMIN,
				subtabs: [],
			},
			{
				title: 'Rewalidacja cache',
				translationKey: null,
				icon: 'edit-outline',
				href: '/panel/cache-revalidation',
				requieredPermission: [EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
				subtabs: [],
			},
		],
		requieredPermission: [EUserPermissions.ADMIN, EUserPermissions.CMS_PL, EUserPermissions.CMS_EN],
	},
}
